export default "__VITE_ASSET__CGN2xb6J__"